import { ComponentProps } from "react";

export function ShortToursStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M34 10.7723V28.2277C34 29.2126 33.1797 29.9787 32.25 29.9787C31.2656 29.9787 30.5 29.2126 30.5 28.2277V21.0595L21.0938 29.5957C19.9453 30.5259 18.25 29.7598 18.25 28.2277V21.0595L8.84375 29.5957C7.69531 30.5259 6 29.7598 6 28.2277V10.7723C6 9.24017 7.69531 8.4741 8.84375 9.40433L18.25 17.8858V10.7723C18.25 9.24017 19.9453 8.4741 21.0938 9.40433L30.5 17.8858V10.7723C30.5 9.78736 31.2656 9.02129 32.1953 9.02129C33.1797 9.02129 34 9.78736 34 10.7723Z" />
        </svg>
    );
}
